import Vue from 'vue'
import App from './App.vue'
import store from "./store/index";
import router from "./router/router";
import VueRouter from "vue-router";

//import components
import Tabs from "./components/Tabs/Tabs";
import Tab from "./components/Tabs/Tab";

Vue.use(VueRouter);

Vue.config.productionTip = false;

Vue.component('v-tabs', Tabs);
Vue.component('v-tab', Tab);

Vue.directive('tooltip', {
  inserted(el, text) {
    el.addEventListener('mouseenter', () => {
      store.dispatch('setTooltipText', {text: text.value, active: true});
    });
    el.addEventListener('mouseleave', () => {
      store.dispatch('setTooltipText', {text: text.value, active: false});
    });
  }
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');

